import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

import {
  IconSizeEnum, ImageRatioEnum, SdBannerComponent, SdIconComponent, SdSkeletonComponent, SdThemeComponent, SkeletonAppearanceEnum
} from '@seb/web-design-system/core';

import type { IBlockQuote } from './blockquote.interface';

@Component({
  selector: 'sd-blockquote',
  templateUrl: './blockquote.component.html',
  styleUrls: ['./blockquote.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdBannerComponent,
    SdIconComponent,
    SdSkeletonComponent
  ]
})
export class SdBlockQuoteComponent extends SdThemeComponent {
  @Input()
  isLoading = false;

  @Input()
  customClass = '';

  @Input()
  quote: IBlockQuote;

  @Input()
  isEditorial = true;

  skeletonAppearanceEnum = SkeletonAppearanceEnum;
  imageRatioEnum = ImageRatioEnum;
  iconSizeEnum = IconSizeEnum;
}
